import React from "react";

global.platformURI = 'https://api.deviare.africa/'
global.cookieURI = 'http://identity.deviare.africa:80/cookie.php?identity=';
global.keycloak = 'http://identity.deviare.africa:80/cookie.php?identity=';
global.eLearningURI = 'https://accounts.simplilearn.com/api/v1/get-course-catalogue';
global.keycloakURL = 'https://identity.deviare.africa/auth';
global.keycloakRealm = 'Deviare';
global.keycloakClientId = 'reactjsclient';
global.keycloakRelay = 'https://identity.deviare.africa/auth/realms/Deviare/protocol/saml/clients/{realm_client}?RelayState=';
global.keycloakDigitalSkills = 'https://identity.platform.digitalskillsonline.net/auth';
global.copilotWebchatURL = 'https://copilotstudio.microsoft.com/environments/Default-766ed5d1-7eb1-46ef-bc6f-fe163f2e86b2/bots/cr971_echo/webchat?__version__=2';
global.copilotConnectionURL = 'https://default766ed5d17eb146efbc6ffe163f2e86.b2.environment.api.powerplatform.com/copilotstudio/dataverse-backed/authenticated/bots/cr971_echo/conversations?api-version=2022-03-01-preview';